<template>
 <div class="info">
   <div class=" layout-column inst-view">
     <header class="instance-header">
       <span class="instance-title">{{ model.title }}</span>
     </header>
     <section class="instance-content flex position-relative" :class="stateClass">
       <div v-if="loaded===1" class="full-parent scroll-y">
         <div class="approve-result" :class="seal"></div>
         <div class="instance-data">
           <div class="participant layout">
             <div class="circle participant-logo">{{ model.createUserName && model.createUserName[0] }}</div>
             <div class="participant-info layout-column">
               <div class="participant-name">{{ model.createUserName }}</div>
               <div class="participant-desc" v-html="state"></div>
             </div>
           </div>
            <info-detail v-if="infoType==='contract'" :type="infoType" :id="dataId" class="inst-form"></info-detail>
            <receipt-info-detail v-if="infoType==='receipt'" class="inst-form"></receipt-info-detail>
         </div>
         <logs :data="logs"/>
       </div>
     </section>
     <footer class="instance-footer">
       <div  class="  flex layout justify-center">
         <div @click.stop="back" class="menu">
           <div class="menu-icon  iconfont icon-pagearr2"></div>
           <div class="menu-label">返回</div>
         </div>
       </div>
       <div v-if="canRevoke" class="revoke  flex layout justify-center">
         <div @click.stop="revoke" class="menu">
           <div class="menu-icon iconfont icon-revoke"></div>
           <div class="menu-label">撤销</div>
         </div>
       </div>
       <div v-if="my_reject" class=" layout flex">
         <div @click.stop="modify" class="menu flex">
           <div class="menu-icon iconfont el-icon-edit"></div>
           <div class="menu-label">修改</div>
         </div>
       </div>

       <div v-if="stepId" class="layout instance-operate">
         <div @click.stop="approve(0)" class="operate">拒绝</div>
         <div @click.stop="approve(1)" class="operate active">同意</div>
       </div>
     </footer>
   </div>
 </div>
</template>

<script>
import {Message, MessageBox, Popup} from "@maidi/common";
import CacheService from "@/service/catch";
import Logs from "@/views/components/instance/logs";
import Opinion from "@/views/components/instance/opinion";
import {EInstanceState, EStepState, InstanceService} from "@/views/components/instance/instance";
import {ActivateType} from "@/views/components/workflow/process/process";
import InfoDetail from "./info-detail";
import ReceiptInfoDetail from "./receipt-info-detail";


export default {
  name: "info",
  components: {Logs, InfoDetail, ReceiptInfoDetail},
  data() {
    return {
      id: "",
      loaded: -1,
      model: {},
      infoType: this.$route.query.type,
      dataId: this.$route.query.dataId,
    };
  },
  mounted() {
    this.id = this.$route.query.insId;

    this.init();
  },
  methods: {

    async init() {
      const model = await InstanceService.info(this.id);

      this.$set(this, "model", model);
      this.loaded = 1;
      this.model.steps.sort((i1, i2) => {
        if (i1.startDate === i2.startDate) {
          return i1.opDate && !i2.opDate ? -1 : (!i1.opDate && i2.opDate ? 1 : i1.opDate > i2.opDate);
        }
        return i1.startDate > i2.startDate
      });
      const user = CacheService.get('user')
      const step = model.steps.find(
          item => item.activate === ActivateType.Notify &&
              item.state === EStepState.Processing &&
              item.participant === user.userID
      );
      if (!step) {
        return;
      }
      await InstanceService.read(model.id, step.id);
      step.State = EStepState.Pass;
    },
    back(){
      this.$router.back()
    },
    // 撤销
    async revoke() {
      if (!this.model.id) {
        return;
      }

      await MessageBox.confirm({
        message: "你确定要撤销申请吗？",
        title: "撤销确认"
      });

      await InstanceService.revoke(this.model.id);
      this.model.steps = this.model.steps.filter(item => item.state >= 0);
      this.model.state = EInstanceState.Revoke;

      await Message.success("流程撤销成功");
    },

    //审批
    async approve(state) {
      if (!this.model.id) {
        return;
      }
      const {opinion} = await Popup(Opinion, {state});

      const result = await InstanceService.approve(
          this.model.id,
          this.stepId,
          state,
          opinion
      );
      if(!result)return Message.error('审批失败，请联系管理员!')
      Message.success("流程审批成功");
      this.init()
    },

    // 修改
    async modify() {
      this.$router.push(`/add-contract?id=${this.$route.query.dataId}`);
    }
  },

  computed: {
    logs() {
      if (this.loaded !== 1) {
        return [];
      }
      const logs = [
        {
          name: "发起申请",
          sequence: 0,
          activate: "",
          state: 1,
          items: [
            {
              state: 1,
              participant: this.model.creatorUserId,
              participantName: this.model.createUserName,
              sequence: 1,
              startDate: this.model.creationTime,
              opDate: this.model.creationTime,
              opinion: ""
            }
          ]
        }
      ];
      this.model.steps.reduce((list, item) => {
        //拒绝后可能被再次提交审批
        //|| list.some(item => item.state === 0)
        if (item.state === EStepState.Discard) {
          return list;
        }
        let node =
            (item.state < 0 || item.activate === ActivateType.Notify) &&
            list.find(
                node =>
                    node.groupId === item.groupID &&
                    node.sequence === item.nodeSequence &&
                    (node.state < 0 || node.activate === ActivateType.Notify)
            );
        if (!node) {
          node = {
            groupId: item.groupID,
            name: item.nodeName,
            sequence: item.nodeSequence,
            activate: item.activate,
            state: item.state,
            instId: this.id,
            title: this.model.title,
            items: []
          };
          list.push(node);
        }
        node.state = Math.max(node.state, item.state);
        node.items.push({
          state: item.state,
          participant: item.participant,
          participantName: item.participantName,
          sequence: item.sequence,
          startDate: item.startDate,
          opDate: item.opDate,
          opinion: item.opinion
        });
        return list;
      }, logs);
      if (this.model.State === EInstanceState.Revoke) {
        logs.push({
          name: "撤销",
          state: EStepState.Revoke,
          sequence: logs.length + 1,
          items: [
            {
              state: EStepState.Revoke,
              participant: this.model.creatorUserId,
              participantName: this.model.createUserName,
              sequence: 1,
              startDate: this.model.creationTime,
              opDate: this.model.creationTime
            }
          ]
        });
      }
      logs.forEach((item, index) => (item.sequence = index + 1));
      return logs;
    },
    // 状态
    state() {
      if (this.loaded !== 1) {
        return "";
      }
      // TODO
      // const Names = JSON.parse(this.model.ParticipantName || '[]');
      // const userName = Names.map(user => `<span class="participant-desc-name" data-id="${user.UserId}" data-name="${user.UserName}">${user.UserName}</span>`).join("");
      // return `等待${userName}审批`;
      if (this.stepId) return "等待我审批";
      else if (this.model.state === EInstanceState.Processing) {
        const Names = JSON.parse(this.model.participantName || "[]");
        const userName = Names.map(
            user =>
                `<span class="participant-desc-name" data-id="${user.UserId}" data-name="${user.UserName}">${user.UserName}</span>`
        ).join("");
        return `等待${userName}审批`;
      } else if (this.model.State === EInstanceState.Failed)
        return "审批被拒绝";
      else if (this.model.State === EInstanceState.Pass) return "审批通过";
      else if (this.model.State === EInstanceState.Discard) return "已作废";
      else if (this.model.State === EInstanceState.Revoke) return "已撤销";
      return ''
    },
    // 状态类名
    stateClass() {
      if (this.loaded !== 1) {
        return "";
      }
      switch (this.model.state) {
        case EInstanceState.Processing:
          return `state-processing`;
        case EInstanceState.Failed:
          return "state-failed";
        case EInstanceState.Pass:
          return "state-pass";
        case EInstanceState.Discard:
          return "state-discard";
        case EInstanceState.Revoke:
          return "state-revoke";
      }
      return ''
    },

    seal() {
      if (this.loaded !== 1) {
        return "";
      }
      if (this.model.state === EInstanceState.Failed) return "failed";
      else if (this.model.state === EInstanceState.Pass) return "pass";
      else if (this.model.state === EInstanceState.Revoke) return "revoke";
      return ''
    },
    me() {
      const me = CacheService.get('user');
      return me && me.userID;
    },
    stepId() {
      const me = this.me;
      const step = this.model.steps && this.model.steps.find(step => {
        return (
            step.activate !== ActivateType.Notify &&
            step.state === -1 &&
            step.participant === me
        );
      });
      return step && step.id;
    },
    canRevoke() {
      if (this.model.state !== -1) {
        return false;
      }
      return this.model.creatorUserId === this.me;
    },
    my_reject() {
      const me = this.me;
      return this.model.state == 0 && this.model.creatorUserId == me;
    },
  }
};
</script>
<style scoped lang="scss">
@import "../../../assets/css/global";



.inst-view {
  width: 980px;
  margin: 0 auto;
  background: #fff;

  .instance-data {
    .inst-form {
      margin-bottom: 10px;
    }
  }
}

.instance-header {
  background-color: $color-bg;
  font-weight: 500;
  font-size: 1.8rem;
  position: relative;
  border-bottom: 1px solid $color-border;
  display: block;
  padding: 0 20px;
  line-height: 40px;
}


.state-processing .participant-desc {
  color: #d99b48;
}

.state-failed .participant-desc {
  color: $color-error;
}

.state-pass .participant-desc {
  color: $color-success;
}

.state-discard .participant-desc,
.state-revoke .participant-desc {
  color: $color-font-light;
}

//background-color: $color-bg-active;
.instance-content {
  .scroll-y {
    overflow-y: auto;
    overflow-x: hidden;
  }

  .approve-result {
    width: 120px;
    height: 94px;
    position: absolute;
    right: 10px;
    top: 0;
    transform: translate(20px, 50px) scale(2);
    opacity: 1;
    z-index: -1;
    transition: transform 0.15s ease-out, opacity 0.15s ease-out;
  }

  .approve-result.pass {
    background: url("../../../assets/img/pass.png") no-repeat;
    background-size: 100%;
  }

  .approve-result.revoke {
    background-image: url("../../../assets/img/revoke.png");
    background-size: contain;
  }

  .approve-result.failed {
    background: url("../../../assets/img/failed.png") no-repeat;
    background-size: 100%;
  }

  .approve-result.pullout {
    z-index: 0;
    transform: translate(0) scale(1);
  }
}

.instance-data {
  padding: 0 20px;
  border-bottom: 1px solid $color-border;
  background-color: $color-bg;
}

.participant {
  position: relative;
  text-align: center;
  margin-bottom: 10px;
  height: 70px;
  padding: 10px 0;
  border-bottom: 1px solid $color-border;

  .participant-logo {
    width: 50px;
    height: 50px;
    line-height: 50px;
    border-radius: 50%;
    text-align: center;
    background-color: $color-primary;
    color: $color-bg;
    cursor: pointer;
    font-size: 1.8rem;
    padding: 0 5px;
    margin-right: 10px;
  }

  .participant-info {
    justify-content: center;
    text-align: left;

    .participant-name {
      font-size: 1.6rem;
      height: 30px;
      line-height: 25px;
      color: $color-font-deep;
    }

    .participant-desc {
      font-size: 1.2rem;
      height: 16px;
      line-height: 15px;

      /deep/ .participant-desc-name {
        margin-right: 5px;
        cursor: pointer;

        &:last-child {
          margin-right: 0;
        }
      }
    }
  }
}


.menu {
  width: 40px;
  height: 35px;
  text-align: center;
  font-size: 1.2rem;
  cursor: pointer;

  .menu-icon {
    color: $color-font;
    height: 15px;
    line-height: 15px;
  }

  .menu-label {
    height: 20px;
    line-height: 20px;
  }
}

.instance-footer {
  padding: 5px 15px 5px;
  border-top: 1px solid $color-bg-active;
  display: flex;

  &:empty {
    display: none;
  }
}

.instance-operate {
  .operate {
    line-height: 35px;
    padding: 0 30px;
    font-size: 1.6rem;
    border: 1px solid $color-border;
    cursor: pointer;
    color: $color-primary;
    border-radius: 4px 0 0 4px;
    border-right: none;

    &.active {
      background-color: $color-primary;
      color: $color-bg;
      border-right: 1px solid $color-primary;
      border-color: $color-primary;
      border-radius: 0 4px 4px 0;
    }
  }
}


</style>
